import useTranslate from 'marketing-site/src/library/hooks/useTranslate'
import React, { useMemo } from 'react'
import { IFieldValue } from '../../@types/FormField'
import { testIds } from './Select'

const useTranslatedOptions = (values: IFieldValue[]) => {
  const { translate } = useTranslate()

  return useMemo(() => {
    return values
      .map(({ label, value }) => ({
        value,
        label: translate(label),
      }))
      .sort((prev, next) => (prev.label > next.label ? 1 : -1))
  }, [values, translate])
}

export const SelectOptions = React.memo(({ values }: { values: IFieldValue[] }) => {
  const translatedValues = useTranslatedOptions(values)

  return (
    <>
      {translatedValues.map(({ label, value }) => (
        <option value={value} key={label} data-testid={testIds.option(value)}>
          {label}
        </option>
      ))}
    </>
  )
})
